import { Dispatch } from 'react';
import { I18nGenericData } from 'src/app/i18n';
import { createBlobAsAgent, getBlobAsAgent } from 'src/app/common/network';
import { fileUpload } from 'src/app/common/utils';
import { getLocale } from './survey-creator';

export const localeMapping = (data: I18nGenericData<string>) => {
  return Object.keys(data).reduce((result, key) => {
    return {
      ...result,
      [getLocale(key)]: data[key],
    };
  }, {});
};

export const handleFile = async (file: any, module: string, dispatch: Dispatch<any>) => {
  const createBlobRes = await createBlobAsAgent({ mimeType: file.type, accessLevel: 'anonymous', module }, dispatch);
  await fileUpload(createBlobRes[0].url, file);
  const blobDetail = await getBlobAsAgent({ resourceIds: createBlobRes[0].blobId }, dispatch);
  return blobDetail[0];
};
